"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemViewStyled = void 0;
const constants_1 = require("../../constants");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.RedeemViewStyled = styled_components_1.default.div `
    padding: 10px 0;
    min-height: 100vh;
    h1.site-block-page-title {
        margin-top: 0;
        padding: 2em 0;
        text-transform: uppercase;
        color: $white;
        text-align: center;
        @media screen and ${constants_1.Device.tablet} {
            padding: 1em 0;
            font-size: 2em;
        }
    }
    .redeemLoading {
        @media screen and ${constants_1.Device.tablet} {
            min-height: 100vh;
        }
    }
    @media screen and ${constants_1.Device.tablet} {
        min-height: initial;
        padding: 0 0 50px;
    }
    @media screen and ${constants_1.Device.mobileL} {
        padding: 0 0 24px;
    }

    .posa-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 50%;
        max-width: 50em;
        background: linear-gradient(to right, #0e0e0e 0%, #3d3d3d 100%);
        padding: 2% 3%;
        margin: 2em 0;
        @media screen and ${constants_1.Device.tablet} {
            width: 75%;
        }
        @media screen and ${constants_1.Device.mobileL} {
            width: 100%;
            flex-wrap: wrap;
            padding: 0.5em 2em;
        }
        .posa-content-block {
            width: 50%;
            padding: 0;
            color: white;
            @media screen and ${constants_1.Device.mobileL} {
                width: 100%;
                text-align: center;
            }
        }
        a {
            text-decoration: underline;
        }
        img {
            width: 100%;
            margin-left: 4em;
            @media screen and ${constants_1.Device.mobileL} {
                width: 60%;
                margin-left: 0;
                margin-top: 1em;
            }
        }
        .ar {
            .redeemView,
            .inviteView {
                direction: rtl;
                .site-block {
                    text-align: initial;
                }
            }
        }
    }
`;
const RedeemViewStyledExtended = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(exports.RedeemViewStyled, Object.assign({ className: className }, rest), children));
};
exports.default = RedeemViewStyledExtended;
//# sourceMappingURL=RedeemViewStyled.js.map